import { Button } from "@/components/ui/button/button";

import { useFilters } from "../_hooks/use-filters";

export const ActiveFilterClearAll = ({
  onClearAll,
}: {
  onClearAll?: () => void;
}) => {
  const { clearAll } = useFilters();

  const handleClearAll = () => {
    clearAll();
    onClearAll?.();
  };

  return (
    <Button
      kind="outline"
      variant="neutral"
      color="black"
      size="xs"
      className="px-2 transition group text-xs font-normal text-text-dark-high items-center rounded-lg"
      onClick={handleClearAll}
    >
      Clear all
    </Button>
  );
};
